import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Grid, AppBar, Button, Toolbar, Box } from '@mui/material';
import Progress from '../common/Progress';

@inject('commonStore', 'menuStore', 'cartStore', 'userStore', 'orderStore')
@observer
class Bottom extends Component {
  // 버튼 클릭
  confirm = async isAgreed => {
    const { history, location, commonStore, userStore, orderStore } = this.props;

    userStore.userData.isPointAdded = isAgreed;
    userStore.saveUserData();

    // 결제 페이지로 이동
    history.push({
      pathname: `/${commonStore.companyId}/${commonStore.storeCode}/payment`,
      search: location.search,
      state: { isLiteOrder: orderStore.liteOrder ? true : false },
    });
  };

  render() {
    const { t, menuStore, cartStore } = this.props;
    if (!menuStore.storeData || !cartStore.cartData) return <Progress />;
    return (
      <React.Fragment>
        <AppBar position="fixed" color="primary" className="bottom">
          <Toolbar variant="dense" style={{ padding: '0' }}>
            <Grid container direction={'row'}>
              <Grid item xs>
                <Button fullWidth className="bottom-button" onClick={() => this.confirm(true)}>
                  <Box className="bottom-button-title">{t('common.button.agree')}</Box>
                </Button>
              </Grid>
              <Grid item xs>
                <Button
                  fullWidth
                  color="secondary"
                  variant={'contained'}
                  className="bottom-button"
                  onClick={() => this.confirm(false)}
                >
                  <Box className="bottom-button-title">{t('common.button.disagree')}</Box>
                </Button>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </React.Fragment>
    );
  }
}

export default withRouter(withTranslation()(Bottom));
